import React from 'react';
import { useLocaleContext } from './component/AppProvider/LocaleProvider';
import { RootRouter } from './Routes';
import { IntlProvider } from 'react-intl';
import { Language } from './i18n/trans';

const App = () => {
  const [ locale ] = useLocaleContext()
  return (
    <IntlProvider locale={locale} key={locale} messages={Language[locale].message} defaultLocale="en">
      <RootRouter/>
    </IntlProvider>
  );
}

export default App;
